// Detectar si estamos en localhost
const isLocalhost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

// BASE URL y UPLOADS según entorno (.env)
const BASE_URL = isLocalhost
  ? process.env.REACT_APP_BASE_URL_LOCAL
  : process.env.REACT_APP_BASE_URL_PROD;

const UPLOADS_URL = isLocalhost
  ? process.env.REACT_APP_UPLOADS_URL_LOCAL
  : process.env.REACT_APP_UPLOADS_URL_PROD;

const IMG = isLocalhost
  ? process.env.REACT_APP_UPLOADS_URL_IMG_LOCAL
  : process.env.REACT_APP_UPLOADS_URL_IMG;


// Url local
global.URL_BACKEND_SECURITY = `${BASE_URL}/api-security`
global.URL_BACKEND_CATALOGO = `${BASE_URL}/api-catalogo`
global.URL_BACKEND_MANTENIMIENTO = `${BASE_URL}/api-maintenance`
global.URL_BACKEND_NEGOCIO = `${BASE_URL}/api-negocio`
global.URLBACKEND_REPORTS = `${BASE_URL}/api-reporteria`
global.URLBACKEND_SRI = `${BASE_URL}/api-sri`
global.IMG = `${BASE_URL}/assets/`
global.IMG2 = IMG
global.IMGProd = `http://localhost/`

// Url AWS
//global.URL_BACKEND_SECURITY = "http://3.145.112.113/api-security"
//global.IMG = "http://3.145.112.113/assets/"

// SECUTIRY
global.CANAL = "49a5f60a-9f56-4feb-bcf1-5377c6152ef8"

// API security
global.LOGIN = global.URL_BACKEND_SECURITY + "/login"
global.SENDLINK = global.URL_BACKEND_SECURITY + "/sendLink"
global.CHANGEPASSWORD = global.URL_BACKEND_SECURITY + "/changePassword"
global.ESTABLISHMENTS = global.URL_BACKEND_SECURITY + "/business/establishment"
global.MODULES = global.URL_BACKEND_SECURITY + "/business/modules"

// API catalogo
global.DEPARTAMENTOS = global.URL_BACKEND_CATALOGO + "/departamentos"
global.BODEGASTIPO = global.URL_BACKEND_CATALOGO + "/bodegaTipo"
global.GETBODEGA = global.URL_BACKEND_CATALOGO + "/getBodegas"
global.STATUS_PROD = global.URL_BACKEND_CATALOGO + "/statusProd"
global.CAT_X_DEPAR = global.URL_BACKEND_CATALOGO + "/categoria_x_departamentos/"
global.PROD_X_CAT = global.URL_BACKEND_CATALOGO + "/tipoProd_x_categoria/"
global.MARCA_X_TIPROD = global.URL_BACKEND_CATALOGO + "/marcaModeloMater_x_tipoProd/"

// API maintenance
global.PRODUCTS = global.URL_BACKEND_MANTENIMIENTO + "/products"
global.BODEGAS = global.URL_BACKEND_MANTENIMIENTO + "/bodegas"
global.ACCESS_DATA = global.URL_BACKEND_MANTENIMIENTO + "/accessData"
global.PRODUCTS_ID = global.URL_BACKEND_MANTENIMIENTO + "/productById"
global.SAVE_PRODUCTS = global.URL_BACKEND_MANTENIMIENTO + "/saveProducts"
global.SAVE_BODEGA = global.URL_BACKEND_MANTENIMIENTO + "/saveBodega"
global.SAVE_GET_MEDIA = global.URL_BACKEND_MANTENIMIENTO + "/getMediaProducts"
global.SAVE_MEDIA_PRODUCTS = global.URL_BACKEND_MANTENIMIENTO + "/saveMediaProducts"
global.DELETE_PRODUCTS = global.URL_BACKEND_MANTENIMIENTO + "/deleteProducts"
global.PARAMETER_ID = global.URL_BACKEND_MANTENIMIENTO + "/parameterById"
global.SAVE_PARAMETERS = global.URL_BACKEND_MANTENIMIENTO + "/saveParameters"
global.GET_TEMPLATES = global.URL_BACKEND_MANTENIMIENTO + "/getTemplates"
global.SAVE_TEMPLATES = global.URL_BACKEND_MANTENIMIENTO + "/saveTemplates"
global.SAVE_ACCESS = global.URL_BACKEND_MANTENIMIENTO + "/saveAccess"
global.USERS_MODULE = global.URL_BACKEND_MANTENIMIENTO + "/users"
global.USERS_ID = global.URL_BACKEND_MANTENIMIENTO + "/usersById"
global.SAVE_USERS = global.URL_BACKEND_MANTENIMIENTO + "/saveUsers"
global.DELETE_USERS = global.URL_BACKEND_MANTENIMIENTO + "/deleteUsers"
global.BUSINESS_INFO = global.URL_BACKEND_MANTENIMIENTO + "/businessInfo"
global.BUSINESS_SAVEINFO = global.URL_BACKEND_MANTENIMIENTO + "/saveBusinessInfo"
global.BUSINESS_SAVEIMG = global.URL_BACKEND_MANTENIMIENTO + "/saveBusinessImg"
global.USER_SAVESIGNINVOICE = global.URLBACKEN_MAINTENANCE + '/saveSignInvoice'

// negocio
global.ORDENES = global.URL_BACKEND_NEGOCIO + "/getOrdenes"
global.ORDENES_PENDING_ENVIO = global.URL_BACKEND_NEGOCIO + "/getOrdenesPendienteEnvio"
global.COMPROBANTE = global.URL_BACKEND_NEGOCIO + "/saveComprobantes"
global.SAVE_ORDER_CONFIRM = global.URL_BACKEND_NEGOCIO + "/saveOrderConfirm"
global.SAVE_TRACK = global.URL_BACKEND_NEGOCIO + "/updateTracking"

// API REPORTS
global.CLIENT_REPORT = global.URLBACKEND_REPORTS + '/module/reports/getClientData'
global.CLIENT_REPORTBYMONTH = global.URLBACKEND_REPORTS + '/module/reports/getClientDataByMonth'
global.CLIENT_EARN_REPORT = global.URLBACKEND_REPORTS + '/module/reports/getEarnData'
global.CLIENT_ERANBYMONTH = global.URLBACKEND_REPORTS + '/module/reports/getEarnDataByMonth'
global.CLIENT_STATUS = global.URLBACKEND_REPORTS + '/module/reports/getStatusData'
global.CLIENT_STATUS_SERVICE = global.URLBACKEND_REPORTS + '/module/reports/getStatusDataByService'

// API SRI
global.INVOICES = global.URLBACKEND_SRI + '/invoices'
global.INVOICES_TO_EMAIL = global.URLBACKEND_SRI + '/invoicesToEmail'

global.BUSINESS_PENDING_INVOICE = '/empresa/modulos/facturacion-pendiente/:moduleId'
global.BUSINESS_HISTORY_INVOICE = '/empresa/modulos/facturacion-historial/:moduleId'
global.BUSINESS_INVOICE_TEMPLATE = '/empresa/modulos/factura/:moduleId'


global.ORDENES_PENDIENTES = "CONFIGH0013"
global.ORDENES_PAGADAS = "CONFIGH0014"

global.IMGPerfil = 'http://localhost/EasyBuy/uploads/'


global.GET_IP = "https://api.bigdatacloud.net/data/client-ip"
global.IP = ""

// routes
global.ROUTE_LOGIN = ""
global.FORGOTPASSWORD = "/enviar-link"
global.FORGOTPASSWORDMOBILE = "/enviar-linkapp"
global.RESETPASSWORD = "/cambiar-credenciales/:token"
global.RESETPASSWORDLINK = "/cambiar-credenciales"
global.RESETPASSWORDMOBILE = "/cambiar-credencialesapp/:token"
global.ROUTE_DASHBOARD = "/dashboard"
global.ROUTE_ESTABLISHMENTS = "/establecimientos"
global.BUSINESS_MODULE_TEMPLATES = "/empresa/modulos/plantillas/:moduleId"
global.PERFIL_USER = "/user/perfil"
global.ROUTE_WIDGET = "/widget"
global.BUSINESS_MODULE = "/empresa/modulos/:businessId"
global.BUSINESS_MODULE_PRODUCTS = "/empresa/modulos/mantenimiento/productos/:moduleId"
global.BUSINESS_MODULE_USERS = "/empresa/modulos/mantenimiento/usuarios/:moduleId"
global.BUSINESS_MODULE_BUSINESS = "/empresa/modulos/mantenimiento/empresa/:moduleId"
global.BUSINESS_MODULE_INVOICE = "/empresa/modulos/mantenimiento/facturas/:moduleId"
global.BUSINESS_MODULE_BODEGAS = "/empresa/modulos/mantenimiento/bodegas/:moduleId"
global.BUSINESS_MODULE_CATALOGOS = "/empresa/modulos/mantenimiento/catalogos/:moduleId"

global.NEGOCIO_MODULE_ORDENES = "/empresa/modulos/negocio/ordenes-compra-pendientes/:moduleId"
global.NEGOCIO_MODULE_ORDENES_PAGADAS = "/empresa/modulos/negocio/ordenes-compra-pagadas/:moduleId"
global.NEGOCIO_MODULE_ENVIOSEGUI = "/empresa/modulos/negocio/envio-seguimiento/:moduleId"

global.BUSINESS_MODULE_SHIFTS = "/empresa/modulos/turnos/horarios/:moduleId"
global.BUSINESS_MODULE_SHIFTS_CONTROL = "/empresa/modulos/turnos/control/:moduleId"

global.BUSINESS_MODULE_REPORTS = "/empresa/modulos/reporteria/clientes/:moduleId"
global.BUSINESS_MODULE_REPORTS_EARN = "/empresa/modulos/reporteria/ganancias/:moduleId"
global.BUSINESS_MODULE_REPORTS_STATUS = "/empresa/modulos/reporteria/estadisticas/:moduleId"

global.ROUTE_HOME = "*"
global.ROUTE_ANY = "/*"
global.URLPROD = "http://localhost/"
